import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionTier } from 'src/app/_models';
import { LookupService, UserService } from 'src/app/_services';

@Component({
  selector: 'app-subscription-tier',
  templateUrl: './subscription-tier.component.html',
  styleUrls: ['./subscription-tier.component.scss']
})
export class SubscriptionTierComponent implements OnInit {
  subscriptionTiers: SubscriptionTier[];
  constructor(private lookupService: LookupService, private userService:UserService, private router: Router) { }

  ngOnInit(): void {
    this.lookupService.getSubscriptions().subscribe(data => {
      this.subscriptionTiers = data;
    });
  }

  subscribe(plan: SubscriptionTier)
  {
      this.userService.setUserSubscription(plan);
      this.router.navigate(['/register']);
  }

}

  // sendSubscriptionTierReqeust() {
  //     this.loading = true;
  //     this.userService.sendSubscriptionTierReqeust(this.model)
  //       .subscribe(
  //         data => {
  //           this.loading = false;
  //           this.alertService.success(data.message, true);
  //           this.router.navigate(['/home']);
  //         },
  //         (error: HttpErrorResponse) => {
  //           console.log(`Error: ${error}`);
  //           this.loading = false;
  //         }
  //       );
  //   }


